import styled from '@emotion/styled';

const RightChunk = styled.div({
  marginTop: '-0.3rem',
  textAlign: 'right',
  width: '100%',
});

export default RightChunk;
